import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loyaltyService } from '../../services/loyaltyService';

export const useGetLoyaltyStatus = () => {
  return useQuery({
    staleTime: 1000 * 60,
    queryKey: [QUERY_KEYS.loyalty.status],
    queryFn: () =>
      loyaltyService.status().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
